var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultidashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 438.99,
    height: 378.474,
    viewBox: "0 0 438.99 378.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#ececf5;}.c{clip-path:url(#a);}.d{fill:#fff;}.e{fill:#494e6d;}.f{fill:#4ac6bd;}.g{fill:#50a5a0;}.h{fill:#f7931e;}.i{fill:#fb8a60;}.j{fill:#e56542;}.k{fill:#1c5276;}.l{fill:#fb855f;}.m{fill:#424669;}.n{fill:#fd8b66;}.o{fill:#8e3332;}.p{fill:#3b9e97;}.q{fill:#24273b;}.r{fill:#ea6868;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M322,643.464S168.044,603.105,205.349,476.989c26-87.892,89.829-23.348,110.193-120,22.159-105.17,207.707-60.942,201.648,45.732s211.948,139.72,68.072,229.625S322,643.464,322,643.464Z",
    transform: "translate(-199.52 -296.933)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-184.517 -296.933)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(188.555 296.933)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M517.19,402.724c6.059-106.673-179.488-150.9-201.648-45.732-20.364,96.649-84.194,32.1-110.193,120C168.044,603.105,322,643.464,322,643.464s8.342,5.5,23.27,11.943h195.5a303.455,303.455,0,0,0,44.489-23.058C729.137,542.444,511.131,509.4,517.19,402.724Z",
    transform: "translate(-199.52 -296.933)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-59.64 -44.395)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 108.944)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M56.217,693.08q-2.645,0-5.31-.177a78.16,78.16,0,1,1,64.017-129.458,77.649,77.649,0,0,1,19.167,56.668l-1.611-.107,1.611.107A78.168,78.168,0,0,1,56.217,693.08ZM56,539.981a74.932,74.932,0,0,0-4.874,149.7q2.552.17,5.09.17a74.932,74.932,0,0,0,4.874-149.7Q58.534,539.981,56,539.981Z",
    transform: "translate(22.06 -536.751)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.138 124.472)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M152.517,756.57q-2.744,0-5.507-.184a80.9,80.9,0,1,1,5.507.184Zm-.229-158.9a77.833,77.833,0,1,0,77.77,83.009l1.611.107-1.611-.107a77.83,77.83,0,0,0-72.483-82.833Q154.924,597.672,152.288,597.672Z",
    transform: "translate(-71.336 -594.442)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.059 115.025)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M75.15,686.266q-2.148,0-4.311-.144a63.326,63.326,0,1,1,4.311.144Zm-.178-123.693A60.23,60.23,0,0,0,71.054,682.9q2.051.137,4.091.137a60.23,60.23,0,0,0,3.918-120.326Q77.011,562.573,74.971,562.573Z",
    transform: "translate(-11.597 -559.343)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208.343)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M858.569,344.842q-3.6,0-7.23-.241a106.3,106.3,0,1,1,7.23.241Zm-.306-209.617a103.854,103.854,0,1,0,7.012.234Q861.759,135.224,858.263,135.224Z",
    transform: "translate(-751.991 -131.994)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(293.448 30.562)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1135.648,380.285q-2.281,0-4.577-.153a67.231,67.231,0,1,1,4.577.153Zm-.19-131.516a64.141,64.141,0,0,0-4.172,128.141q2.185.146,4.358.145a64.141,64.141,0,0,0,4.172-128.141Q1137.63,248.769,1135.457,248.769Z",
    transform: "translate(-1068.177 -245.539)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(256.787 7.853)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1021.26,339.487q-3.017,0-6.057-.2a88.972,88.972,0,1,1,6.057.2Zm-.253-175.085a85.926,85.926,0,1,0,85.857,91.641l1.611.107-1.611-.107a85.923,85.923,0,0,0-80.02-91.446Q1023.918,164.4,1021.007,164.4Z",
    transform: "translate(-931.974 -161.172)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(323.742 244.313)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1240.905,1159.86q-2.034,0-4.082-.136a60.086,60.086,0,1,1,63.948-55.958l-1.612-.108,1.612.108a60.093,60.093,0,0,1-59.866,56.094Zm-.169-116.948a56.858,56.858,0,0,0-3.7,113.589c1.279.085,2.555.127,3.819.127a56.927,56.927,0,0,0,56.692-53.077h0a56.856,56.856,0,0,0-52.95-60.511Q1242.662,1042.911,1240.736,1042.912Z",
    transform: "translate(-1180.729 -1039.682)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(279.311 212.73)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1107.848,1106.46q-3.116,0-6.253-.209a91.859,91.859,0,1,1,6.253.209Zm-.261-180.885a88.825,88.825,0,0,0-5.778,177.454q3.026.2,6.034.2a88.825,88.825,0,0,0,5.778-177.454Q1110.595,925.574,1107.587,925.574Z",
    transform: "translate(-1015.657 -922.344)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(247.069 27.707)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1123.534,412.032c-.135,0-.272,0-.408-.014a6.076,6.076,0,1,1,.408.014Zm-.008-11.354a5.275,5.275,0,1,0,.354.012Q1123.7,400.678,1123.526,400.678Z",
    transform: "translate(-1117.449 -399.871)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(184.517 377.056)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 161.564)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M233.042,1297.87a42,42,0,0,1-2.941,13.063c-.1.234-.2.464-.316.689h-5.766l-.222-.689H210.189c-4.183-6.172-7.218-15.79-6.923-27.824.673-27.356-35.464-73.96-9.122-86.457,19.551-9.273,42.4,19.4,36.059,42.289-2.858,10.311-3.4,18.448-2.908,24.674a36.586,36.586,0,0,0,4,14.765c.972,1.809,1.837,6.8,1.952,12.719A65.543,65.543,0,0,1,233.042,1297.87Z",
    transform: "translate(-184.517 -1194.863)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.75 35.301)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M276.9,1407.474h-1.973l-.222-.689c-1.448-4.5-3.01-9.191-4.61-14.006-8.264-24.85-16.807-50.549-15.848-65.885a.948.948,0,0,1,.993-.878.936.936,0,0,1,.878.992c-.919,14.724,7.637,40.755,15.364,63.99.131.394.263.792.394,1.185,1.554,4.684,3.072,9.248,4.5,13.641l.307.96C276.755,1407.015,276.828,1407.248,276.9,1407.474Z",
    transform: "translate(-254.176 -1326.016)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M375.333,1302.061c-14.843,14.519-34.3,15.786-39.254,47.076-.037.226-.074.455-.107.689H323.578s0,0,0-.008c-.14-.213-.283-.443-.439-.681-.185-.3-.377-.619-.574-.96a38.832,38.832,0,0,1-4.889-14.826,45.781,45.781,0,0,1,2.276-20.142,102.75,102.75,0,0,1,4.446-11.389c5.139-10.885,8.211-9.671,12.776-29.813,5.742-25.33,9.458-26,18.239-24.317C377.65,1251.966,390.869,1286.865,375.333,1302.061Z",
    transform: "translate(-281.614 -1233.066)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M375.434,1311.182c-9.581,11.541-18.144,38.311-25.7,61.931-.939,2.932-1.862,5.824-2.777,8.646-1.468,4.548-2.912,8.933-4.348,13.063-.078.23-.156.463-.238.689h-1.985s0,0,0-.008c.078-.226.156-.455.234-.681,2.137-6.132,4.3-12.833,6.538-19.834.262-.808.521-1.624.783-2.445,7.977-24.944,16.225-50.738,26.04-62.562a.944.944,0,0,1,1.321-.119A.933.933,0,0,1,375.434,1311.182Z",
    transform: "translate(-298.437 -1278.752)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M345.64,1626.094c-.037.226-.074.455-.107.689H330.679l-.221-.689Z",
    transform: "translate(-291.176 -1510.024)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M470.165,603.113,320.975,846.165a17.829,17.829,0,0,0,15.194,27.155H634.549a17.829,17.829,0,0,0,15.195-27.155L500.554,603.113A17.828,17.828,0,0,0,470.165,603.113Z",
    transform: "translate(-282.3 -594.611)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(179.637 60.543)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 19.865,
    cy: 19.865,
    r: 19.865,
    transform: "translate(2.226 159.387)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M858.595,960.952h32.537l8.8-126.088s-23.226-34.839-48.015.563Z",
    transform: "translate(-851.916 -819.546)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(341.025 212.113)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1479.229,1441.491a23.989,23.989,0,0,1-1.679,7.46c-.058.133-.117.265-.18.393h-3.293l-.126-.393h-7.771c-2.389-3.525-4.122-9.018-3.954-15.89.384-15.623-20.253-42.237-5.209-49.373,11.165-5.3,24.214,11.081,20.593,24.15a40.859,40.859,0,0,0-1.661,14.091,20.906,20.906,0,0,0,2.284,8.432c.555,1.033,1.049,3.881,1.115,7.263A37.323,37.323,0,0,1,1479.229,1441.491Z",
    transform: "translate(-1451.517 -1382.666)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.708 20.159)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1504.277,1504.083h-1.127l-.126-.394c-.827-2.572-1.719-5.249-2.633-8-4.72-14.192-9.6-28.868-9.05-37.625a.541.541,0,0,1,.567-.5.535.535,0,0,1,.5.567c-.525,8.408,4.361,23.274,8.774,36.543.075.225.15.452.225.677.888,2.675,1.754,5.282,2.567,7.79l.176.548C1504.193,1503.82,1504.235,1503.954,1504.277,1504.083Z",
    transform: "translate(-1491.299 -1457.564)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1560.488,1443.884c-8.477,8.291-19.59,9.015-22.417,26.884-.021.129-.042.26-.061.393h-7.078s0,0,0,0c-.079-.122-.161-.253-.251-.389-.105-.171-.215-.354-.328-.548a22.177,22.177,0,0,1-2.792-8.467,26.143,26.143,0,0,1,1.3-11.5,58.641,58.641,0,0,1,2.539-6.5c2.935-6.216,4.689-5.523,7.3-17.026,3.279-14.466,5.4-14.85,10.416-13.887C1561.812,1415.276,1569.361,1435.206,1560.488,1443.884Z",
    transform: "translate(-1506.967 -1404.483)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1560.547,1449.093c-5.471,6.591-10.362,21.878-14.674,35.367-.536,1.675-1.063,3.326-1.585,4.937-.839,2.6-1.663,5.1-2.483,7.46-.044.131-.089.265-.136.394h-1.133s0,0,0,0c.045-.129.089-.26.133-.389,1.22-3.5,2.455-7.329,3.734-11.327.15-.462.3-.927.447-1.4,4.556-14.245,9.266-28.976,14.871-35.728a.539.539,0,0,1,.754-.068A.533.533,0,0,1,1560.547,1449.093Z",
    transform: "translate(-1516.575 -1430.573)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1543.532,1628.932c-.021.129-.042.26-.061.393h-8.483l-.126-.393Z",
    transform: "translate(-1512.428 -1562.647)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252.931 36.221)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1150.177,786.72s.44,40.256,11.617,40.121c12.6-.152-1.833-41.844-1.833-41.844S1154.169,782.72,1150.177,786.72Z",
    transform: "translate(-1143.191 -769.503)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1211.789,906.307s-36.732-17.977-40.716-7.554c-5.412,14.159,37.005,19.618,37.005,19.618C1214.759,918.558,1216.515,909.886,1211.789,906.307Z",
    transform: "translate(-1158.114 -850.736)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1227.236,980.49s.559-44.361,12.792-50.676c7.013-3.62,21.526-2.637,28.927,2.365,7.47,5.048,2.194,48.311,2.194,48.311Z",
    transform: "translate(-1199.509 -874.225)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1143.883,746.17a8.7,8.7,0,0,0,1.264-4.143c-.059-2.033-.353-3.394.775-5.494s-1.376-2.97-2.271-1.105-1.885,5.026-3.783,3.2-1.369-8.539-5.158-6.736c0,0-.512-3.053-1.834-2.678s-.875,3.145-.875,3.145-3.4-1.484-1,5.348c0,0-1.75.183-1.459,1.567.465,2.213,3.429,6.319,6.623,8.78C1141.355,752.055,1143.883,746.17,1143.883,746.17Z",
    transform: "translate(-1128.087 -729.183)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.485 2.697)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1151.138,746.989c-2.961-5.849-2.828-7.709-2.82-7.785l.268.024c0,.018-.117,1.892,2.793,7.639Z",
    transform: "translate(-1148.315 -739.204)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.782 3.143)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1141.45,748.923a36.545,36.545,0,0,1-3.175-7.994l.26-.069a36.241,36.241,0,0,0,3.144,7.921Z",
    transform: "translate(-1138.275 -740.86)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.798 8.458)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1137.073,764.822c-1.115-1.76-2.442-4.059-2.455-4.082l.233-.134c.013.023,1.337,2.317,2.45,4.072Z",
    transform: "translate(-1134.618 -760.606)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1447.627,1547.889l-12.335,12.462a2.383,2.383,0,0,0-.282,3.009h0a2.383,2.383,0,0,0,3.308.643l20.268-13.671-4.918-6.413Z",
    transform: "translate(-1351.061 -1324.625)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M0,0H7.228a0,0,0,0,1,0,0V5.84A3.614,3.614,0,0,1,3.614,9.454h0A3.614,3.614,0,0,1,0,5.84V0A0,0,0,0,1,0,0Z",
    transform: "matrix(0.829, -0.559, 0.559, 0.829, 92.809, 217.644)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1217.882,1599.938l-17.195,3.434a2.383,2.383,0,0,0-1.916,2.337h0a2.383,2.383,0,0,0,2.383,2.382H1225.6l-.492-8.066Z",
    transform: "translate(-1178.705 -1365.566)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M0,0H7.228a0,0,0,0,1,0,0V5.84A3.614,3.614,0,0,1,3.614,9.454h0A3.614,3.614,0,0,1,0,5.84V0A0,0,0,0,1,0,0Z",
    transform: "translate(38.916 228.647)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M1237.925,1195.571h0a9.983,9.983,0,0,1-9.973-9.423c-1.238-22.395-1.782-45.335-1.257-62.162h21.857c-.691,19.167-.86,41.47-.639,61.485A9.988,9.988,0,0,1,1237.925,1195.571Z",
    transform: "translate(-1198.968 -1017.721)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M1241.906,1318.406h0a9.949,9.949,0,0,0-9.934,10.542c1.154,19.3,2.8,47.511,3.656,59.886h16.913c-.671-14.1-.468-43.007-.685-60.6A9.949,9.949,0,0,0,1241.906,1318.406Z",
    transform: "translate(-1202.957 -1159.811)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M1319.87,1195.571h0a9.983,9.983,0,0,1-9.972-9.423c-1.238-22.395-1.782-45.335-1.257-62.162H1330.5c-.691,19.167-.861,41.47-.64,61.485A9.987,9.987,0,0,1,1319.87,1195.571Z",
    transform: "translate(-1258.857 -1017.721)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M1318.187,1317.579h0a9.95,9.95,0,0,0-2.34,14.295c11.75,15.356,28.889,37.823,36.519,47.6l14.022-9.458c-8.441-11.314-24.437-35.393-34.456-49.86A9.95,9.95,0,0,0,1318.187,1317.579Z",
    transform: "translate(-1262.773 -1157.963)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1144.334,986.736a8.7,8.7,0,0,0-2.3-3.67c-1.574-1.288-2.794-1.959-3.641-4.186s-3.145-.908-2.324.991,2.56,4.718-.062,4.955-7.346-4.564-8.469-.52c0,0-2.641-1.614-3.224-.37s1.8,2.722,1.8,2.722-3.349,1.595,3.384,4.259c0,0-1.008,1.441.227,2.129,1.976,1.1,7.02,1.553,10.971.754C1147.121,992.5,1144.334,986.736,1144.334,986.736Z",
    transform: "translate(-1124.222 -910.819)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.219 73.393)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1143.909,1005.018c-6.359-1.6-7.675-2.917-7.728-2.973l.194-.186-.1.093.1-.094c.013.013,1.352,1.328,7.6,2.9Z",
    transform: "translate(-1136.181 -1001.859)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.834 75.719)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1139.155,1013.582a36.541,36.541,0,0,1-8.119-2.842l.119-.242a36.247,36.247,0,0,0,8.042,2.818Z",
    transform: "translate(-1131.036 -1010.498)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.252 79.966)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1148.428,1027.365c-2.06-.311-4.666-.817-4.692-.822l.051-.264c.026,0,2.627.509,4.681.819Z",
    transform: "translate(-1143.736 -1026.279)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1307.286,907.594c-4.627,0-6.737-5.4-5.494-6.648a4.384,4.384,0,0,0,.874-1.352h0a9.109,9.109,0,0,0,.628-2.347l0,0,8.554-7.63c-.462,4.858,1.617,8.268,2.371,10.7S1312.548,907.594,1307.286,907.594Z",
    transform: "translate(-1253.741 -846.432)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1313.687,906.659a8.165,8.165,0,0,1-7.684,4.236,9.122,9.122,0,0,0,.628-2.347l0,0C1306.866,908.411,1315.986,902.261,1313.687,906.659Z",
    transform: "translate(-1257.075 -857.733)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M1345.511,854.663s-.368,4.434-6.815,9c-6.76,4.789.934-9.93.934-9.93Z",
    transform: "translate(-1278.937 -820.211)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1297.772,847.287s-.913,3.821-2.1,8.11c-1.692,6.13-1.836,11.087,4.409,11.087,10.489,0,9.79-17.4,9.79-17.4Z",
    transform: "translate(-1248.796 -815.498)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1343.595,870.941c1.652.676.505,4.878-3.094,5.291C1337.726,876.55,1341.05,869.9,1343.595,870.941Z",
    transform: "translate(-1281.52 -832.705)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.345 73.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1289.467,1014.1l-.49-.223c.041-.089,4.07-8.926,6.23-12.554l.463.275C1293.524,1005.2,1289.507,1014.015,1289.467,1014.1Z",
    transform: "translate(-1288.977 -1001.327)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.54 44.557)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M1201.049,898.951a.516.516,0,0,1-.479-.705,9.384,9.384,0,0,1,2.763-3.418.516.516,0,0,1,.622.823,8.471,8.471,0,0,0-2.425,2.973A.516.516,0,0,1,1201.049,898.951Z",
    transform: "translate(-1200.534 -894.723)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M1276.764,1144.553l16.735-3.218-5.149-18.344-7.08-.322Z",
    transform: "translate(-1235.706 -1016.758)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.192 106.474)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1298.469,1142.363l-6.347-2.657,2.466-14.943.531.088-2.4,14.522,5.954,2.493Z",
    transform: "translate(-1292.122 -1124.764)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.891 106.445)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1402.056,1232.987l-33.031-46.455v-.087l.429-61.791.538,0-.428,61.7,32.93,46.313Z",
    transform: "translate(-1369.025 -1124.654)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.203 106.543)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "q",
    width: 0.538,
    height: 122.082,
    transform: "matrix(0.999, -0.042, 0.042, 0.999, 0, 0.023)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1440.971,1505.09l4.337,5.146,14.022-9.458-4.342-5.987Z",
    transform: "translate(-1355.715 -1288.721)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1242.753,1551.122l17.164.286.516,7.5h-16.913Z",
    transform: "translate(-1210.85 -1329.889)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M1313.349,835.66a25.759,25.759,0,0,1-12.428.119,12.846,12.846,0,0,1-9.011-8.046s6.651,2.574,12.444,2.467S1313.976,832.645,1313.349,835.66Z",
    transform: "translate(-1246.775 -801.207)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 0.733,
    cy: 0.733,
    r: 0.733,
    transform: "translate(53.628 38.845)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 0.733,
    cy: 0.733,
    r: 0.733,
    transform: "translate(48.449 37.585)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.499 41.954)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M1308.811,887.261a.7.7,0,0,1-.641-.352c-.1-.205-.059-.524.377-.749a1.065,1.065,0,0,0,.578-1.068l.266-.038a1.355,1.355,0,0,1-.721,1.345c-.224.115-.32.262-.257.393a.538.538,0,0,0,.7.131l.111.245A1,1,0,0,1,1308.811,887.261Z",
    transform: "translate(-1308.125 -885.054)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1307.545,902.072l-3.566-.331s.455-2.337,2.078-2.162S1307.545,902.072,1307.545,902.072Z",
    transform: "translate(-1255.596 -853.709)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.794 36.43)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M1329.6,866.412a2.253,2.253,0,0,0-1.807-1.344l.027-.538a2.772,2.772,0,0,1,2.27,1.661Z",
    transform: "translate(-1327.796 -864.531)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.309 35.204)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M1306.219,860.974a3.333,3.333,0,0,0-2.393-.387l-.124-.524a3.825,3.825,0,0,1,2.828.472Z",
    transform: "translate(-1303.702 -859.974)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.809 36.798)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M1319.719,871.927a3.014,3.014,0,1,1,3.014-3.014A3.018,3.018,0,0,1,1319.719,871.927Zm0-5.76a2.745,2.745,0,1,0,2.745,2.745A2.748,2.748,0,0,0,1319.719,866.167Z",
    transform: "translate(-1316.705 -865.898)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.202 35.345)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M1295.175,866.528a3.014,3.014,0,1,1,3.015-3.014A3.018,3.018,0,0,1,1295.175,866.528Zm0-5.759a2.745,2.745,0,1,0,2.745,2.745A2.748,2.748,0,0,0,1295.175,860.769Z",
    transform: "translate(-1292.161 -860.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.891 38.84)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "o",
    width: 0.269,
    height: 1.041,
    transform: "translate(0 0.259) rotate(-74.059)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1291.347,931.281s2.318,2.166-5.785,11.159c-8.018,8.9-13.972,14.282-14.7,41l-.874,8.618,32.146-.675.26-8.232s4.264-35.06-.581-46.3C1299.977,932.594,1291.347,931.281,1291.347,931.281Z",
    transform: "translate(-1230.754 -876.885)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1298.519,949.7s-23.744,33.3-14.112,38.932c13.083,7.655,25.407-33.3,25.407-33.3C1311.09,948.775,1302.822,945.624,1298.519,949.7Z",
    transform: "translate(-1239.611 -889.015)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1176.054,1013.626s31.913,24.542,38.718,15.673c7.673-10-34.022-24.428-34.022-24.428S1175.378,1008.015,1176.054,1013.626Z",
    transform: "translate(-1162.06 -930.666)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.803 80.543)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M1266.917,1036.91a.514.514,0,0,1-.365-.151c-2.715-2.715-12.628-7.307-12.728-7.353a.516.516,0,0,1,.432-.937c.415.191,10.18,4.716,13.025,7.561a.516.516,0,0,1-.365.88Z",
    transform: "translate(-1253.525 -1028.422)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1247.916,926.693s-13.293,9.893-15.133,30.224-1.945,31.786-1.945,31.786h-4.3s-.479-25.06,3.636-41.188c2.292-8.984,4.085-14.292,7.263-17.23C1239.967,927.949,1243.5,927.194,1247.916,926.693Z",
    transform: "translate(-1198.988 -873.531)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.334 57.15)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M1241.152,956.083a.516.516,0,0,1-.505-.621c.082-.392,2.051-9.643,6.206-13.8a.516.516,0,0,1,.73.729c-3.94,3.94-5.906,13.186-5.925,13.279A.516.516,0,0,1,1241.152,956.083Z",
    transform: "translate(-1240.635 -941.512)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.673 78.985)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M1254.3,1044.72a21.193,21.193,0,0,1-8.837-2.408,44.28,44.28,0,0,1-7.082-4.253.516.516,0,1,1,.625-.821c.12.091,12.007,9.045,18.86,5.692,6.971-3.41,14.3-19.823,14.369-19.988a.516.516,0,0,1,.944.417c-.3.689-7.551,16.923-14.859,20.5A9.041,9.041,0,0,1,1254.3,1044.72Z",
    transform: "translate(-1238.179 -1022.634)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.043 212.116)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M402.286,1441.5a23.974,23.974,0,0,0,1.679,7.459c.058.134.117.265.18.394h3.293l.127-.394h7.771c2.389-3.525,4.122-9.017,3.954-15.889-.384-15.622,20.252-42.235,5.209-49.371-11.165-5.3-24.213,11.08-20.592,24.149a40.859,40.859,0,0,1,1.66,14.09,20.894,20.894,0,0,1-2.284,8.431c-.555,1.033-1.049,3.881-1.115,7.263A37.391,37.391,0,0,0,402.286,1441.5Z",
    transform: "translate(-372.623 -1382.678)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.689 20.159)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M417.584,1504.089h1.127l.127-.394c.827-2.572,1.719-5.249,2.632-8,4.719-14.191,9.6-28.866,9.05-37.623a.541.541,0,0,0-.567-.5.535.535,0,0,0-.5.567c.525,8.408-4.361,23.273-8.773,36.541l-.225.677c-.888,2.675-1.754,5.281-2.567,7.79l-.176.548C417.669,1503.826,417.626,1503.96,417.584,1504.089Z",
    transform: "translate(-417.584 -1457.572)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M296.276,1443.892c8.476,8.291,19.589,9.015,22.416,26.883.021.129.042.26.061.394h7.078s0,0,0,0c.08-.122.162-.253.251-.389.105-.171.215-.354.328-.548a22.174,22.174,0,0,0,2.792-8.467,26.138,26.138,0,0,0-1.3-11.5,58.6,58.6,0,0,0-2.539-6.5c-2.935-6.216-4.689-5.522-7.3-17.025-3.279-14.465-5.4-14.849-10.415-13.886C294.953,1415.286,287.4,1435.215,296.276,1443.892Z",
    transform: "translate(-292.421 -1404.493)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M341.883,1449.1c5.471,6.59,10.361,21.877,14.673,35.366.536,1.675,1.063,3.326,1.586,4.937.838,2.6,1.663,5.1,2.482,7.46.044.131.089.265.136.394h1.133s0,0,0,0c-.045-.129-.089-.26-.133-.389-1.22-3.5-2.455-7.328-3.733-11.327-.15-.462-.3-.927-.447-1.4-4.556-14.245-9.266-28.974-14.87-35.726a.539.539,0,0,0-.754-.068A.533.533,0,0,0,341.883,1449.1Z",
    transform: "translate(-328.479 -1430.582)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M390.027,1628.932c.021.129.042.26.061.393h8.483l.126-.393Z",
    transform: "translate(-363.755 -1562.65)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M311.581,696.971l-21.663,35.292A11.842,11.842,0,0,0,300.01,750.3h43.326a11.842,11.842,0,0,0,10.093-18.037l-21.663-35.292A11.842,11.842,0,0,0,311.581,696.971Z",
    transform: "translate(-75.739 -288.237)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(241.801 416.68)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 3.797,
    cy: 3.797,
    r: 3.797,
    transform: "translate(0.426 30.469)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M398.62,768.858h6.22l1.682-24.1s-4.44-6.66-9.179.108Z",
    transform: "translate(-397.343 -741.827)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M1501.129,1045.483l-14.176,23.095a11.842,11.842,0,0,0,10.093,18.037H1525.4a11.842,11.842,0,0,0,10.093-18.037l-14.176-23.095A11.842,11.842,0,0,0,1501.129,1045.483Z",
    transform: "translate(-950.581 -542.943)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(557.23 506.222)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 3.134,
    cy: 3.134,
    r: 3.134,
    transform: "translate(0.351 25.142)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1570.3,1096.8h5.132l1.388-19.89s-3.664-5.5-7.574.089Z",
    transform: "translate(-1569.247 -1074.499)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M1157.856,503.565,1143.68,526.66a11.842,11.842,0,0,0,10.093,18.037h28.352a11.842,11.842,0,0,0,10.093-18.037l-14.176-23.095A11.842,11.842,0,0,0,1157.856,503.565Z",
    transform: "translate(-699.703 -146.888)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(464.835 360.36)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 3.134,
    cy: 3.134,
    r: 3.134,
    transform: "translate(0.351 25.142)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1227.028,554.886h5.132L1233.548,535s-3.664-5.5-7.574.089Z",
    transform: "translate(-1225.974 -532.58)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(239.656 472.624)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M393.051,949.848a20.81,20.81,0,0,0-3.532,10.2,39.832,39.832,0,0,0,.93,12.257,63.888,63.888,0,0,0,4.223,12.583A65.091,65.091,0,0,0,401,996.009a37.4,37.4,0,0,0,7.255,7.9q.46.358.936.695c.426.3.83-.4.407-.7a32.773,32.773,0,0,1-7.15-7.283A63.013,63.013,0,0,1,396.078,986,64.9,64.9,0,0,1,391.6,973.7a42.406,42.406,0,0,1-1.386-12.1,21.549,21.549,0,0,1,2.836-10.29q.327-.537.695-1.047c.3-.422-.4-.826-.7-.408Z",
    transform: "translate(-389.374 -949.671)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(256.614 521.495)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M452.669,1139.123c2.319.521,4.737-.051,7.035.6a.407.407,0,0,0,.511-.389c-.085-2.586.018-5.335-.829-7.816-.167-.489-.947-.279-.779.215.825,2.415.718,5.084.8,7.6l.511-.389c-2.307-.654-4.717-.079-7.035-.6-.506-.114-.722.665-.215.779Z",
    transform: "translate(-452.379 -1131.24)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(411.251 359.193)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M1027.485,531.323a11.31,11.31,0,0,1,3.62-1.52,24.907,24.907,0,0,1,4.7-.68,36.96,36.96,0,0,1,10,.764,18.977,18.977,0,0,1,4.384,1.436c.464.23.873-.466.407-.7a25.62,25.62,0,0,0-8.891-2.183,32.849,32.849,0,0,0-10.269.452,12.555,12.555,0,0,0-4.353,1.73c-.427.291-.023.991.407.7Z",
    transform: "translate(-1026.896 -528.244)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(435.238 357.097)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M1116.512,529.228a4.478,4.478,0,0,0,2.3-1.336,3.485,3.485,0,0,0,.782-2.134,8.851,8.851,0,0,0-1.95-5.122c-.3-.422-1-.019-.7.407a8.506,8.506,0,0,1,1.842,4.5,2.749,2.749,0,0,1-.525,1.752,3.636,3.636,0,0,1-1.964,1.156.4.4,0,0,0,.214.779Z",
    transform: "translate(-1116.012 -520.459)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(527.661 485.041)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M1475.234,1008.445a31.086,31.086,0,0,0-4.64-6.672,19.878,19.878,0,0,0-6.52-4.912,12.358,12.358,0,0,0-4.3-1.057c-.519-.028-.518.78,0,.807,5.281.287,9.617,4.46,12.509,8.547a31.451,31.451,0,0,1,2.25,3.694c.24.461.936.054.7-.408Z",
    transform: "translate(-1459.39 -995.803)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(522.611 481.483)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M1443.789,991.773c-1.005-2.385-1.2-5.028-2.414-7.339l-.145.552a10.932,10.932,0,0,1,3.947-1.589c.509-.065.515-.873,0-.807a11.858,11.858,0,0,0-4.355,1.7.412.412,0,0,0-.145.552c1.177,2.243,1.356,4.827,2.333,7.146a.418.418,0,0,0,.5.282.406.406,0,0,0,.282-.5Z",
    transform: "translate(-1440.627 -982.586)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultidashboard);
export default __webpack_public_path__ + "static/media/multidashboard.6ec2291e15e0c99045d51051690843e6.svg";
export { ForwardRef as ReactComponent };